export default "__VITE_ASSET__70ce07fc__"